<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M5.334 5.62c0-1.626 1.276-2.954 2.862-2.954h15.61c1.586 0 2.861 1.328 2.861 2.954v21.913c0 .678-.37 1.302-.963 1.608a1.705 1.705 0 01-1.835-.17l-7.867-6.104-7.87 6.104a1.705 1.705 0 01-1.835.17 1.807 1.807 0 01-.963-1.608V5.62zm2.862-1.036c-.522 0-.98.445-.98 1.036v21.65l8.216-6.372a.927.927 0 011.14 0l8.213 6.372V5.62c0-.591-.457-1.036-.98-1.036H8.196zm-1.203 22.86z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsBookmarkOutline'
}
</script>
